import { Text } from 'slate';
import { BLOCK_DELIMITER_LENGTH } from './constants';
import { OT_BLOCKS } from '../../../types/BlockTypes';

var reduceNodes = function reduceNodes(memo, node) {
  return memo + getNodeLength(node);
};

export default function getNodeLength(node) {
  if (!node) {
    return 0;
  }

  if (Text.isText(node)) {
    return node.text.length;
  }

  return node.nodes.reduce(reduceNodes, OT_BLOCKS.includes(node.type) ? BLOCK_DELIMITER_LENGTH : 0);
}